import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldNote',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as {
	color: 'blue' | 'orange' | 'red' | 'allred' | 'light-blue';
}



const alertUser = computed(() => (props.color === 'allred' || props.color === 'red'));

return { __sfc: true,props, alertUser }
}

})